import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getAuditlogData = payload => api.get(`/platform/admin/audit-logs`, payload)

const reportDownload = payload =>
  api.get(`/platform/admin/audit-logs/download`, payload)

export default {
  getAuditlogData,
  reportDownload,
}
